export default "__VITE_ASSET__46290fee__"